import { Routes, Route, Navigate } from "@/lib/router";
import { AiServiceHub } from "./pages/AiSuite/AiServiceHub";
import { AiServiceView } from "./pages/AiSuite/AiServiceView";
import { AiProductView } from "./pages/AiSuite/AiProductView";
import { AiProductLanding } from "./pages/AiSuite/AiProductLanding";
import { TienditaBotApp } from "./pages/TienditaBot/TienditaBotApp";
import { PublicTienditaOrderStatus, PublicTienditaStore } from "./pages/TienditaBot/PublicTienditaStore";
import { QaLogin } from "./pages/AiSuite/QaLogin";
import { AnalyticsRouteTracker } from "./lib/analytics";

export function App() {
  return (
    <div className="suite-shell min-h-screen text-foreground">
      <div className="suite-noise" />
      <AnalyticsRouteTracker />
      <main className="relative z-10 mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <Routes>
          <Route path="/" element={<Navigate to="/ai-suite" replace />} />
          <Route path="/qa-login" element={<QaLogin />} />
          <Route path="/tienditabot" element={<TienditaBotApp />} />
          <Route path="/tienditabot/store/:slug" element={<PublicTienditaStore />} />
          <Route path="/tienditabot/store/:slug/order/:orderId" element={<PublicTienditaOrderStatus />} />
          <Route path="/ai-suite" element={<AiServiceHub />} />
          <Route path="/ai-suite/landings/:productKind/:productId" element={<AiProductLanding />} />
          <Route path="/ai-suite/products/:productKind/:productId" element={<AiProductView />} />
          <Route path="/ai-suite/:serviceId" element={<AiServiceView />} />
        </Routes>
      </main>
    </div>
  );
}
